(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util"), require("@bingads-webui/edm-resource-identifiers"), require("json-stable-stringify"), require("@bingads-webui-universal/observable"), require("@bingads-webui-universal/time-aware-cache"));
	else if(typeof define === 'function' && define.amd)
		define(["bluebird", "underscore", "@bingads-webui-universal/primitive-utilities", "@bingads-webui/reflection", "@bingads-webui/http-util", "@bingads-webui/url-util", "@bingads-webui/edm-resource-identifiers", "json-stable-stringify", "@bingads-webui-universal/observable", "@bingads-webui-universal/time-aware-cache"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util"), require("@bingads-webui/edm-resource-identifiers"), require("json-stable-stringify"), require("@bingads-webui-universal/observable"), require("@bingads-webui-universal/time-aware-cache")) : factory(root["bluebird"], root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["@bingads-webui/reflection"], root["@bingads-webui/http-util"], root["@bingads-webui/url-util"], root["@bingads-webui/edm-resource-identifiers"], root["json-stable-stringify"], root["@bingads-webui-universal/observable"], root["@bingads-webui-universal/time-aware-cache"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__41__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__59__, __WEBPACK_EXTERNAL_MODULE__74__, __WEBPACK_EXTERNAL_MODULE__76__, __WEBPACK_EXTERNAL_MODULE__78__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 70);
/******/ })
/************************************************************************/
/******/ ({

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__41__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__59__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "odataPlugin", {
  enumerable: true,
  get: function get() {
    return _index.odataPlugin;
  }
});

var _index = __webpack_require__(72);

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.odataPlugin = odataPlugin;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _reflection = __webpack_require__(39);

var _httpUtil = __webpack_require__(41);

var url = _interopRequireWildcard(__webpack_require__(42));

var _edmResourceIdentifiers = __webpack_require__(59);

var _cache = __webpack_require__(73);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// support a mongoDB like orderby object for now: { age : -1, name: 1 }
// for backward compatibility, support array format: [['age', 'desc'], ['name', 'asc]]
function parseOrderBy(orderby) {
  function lowerCaseOrderValue(value) {
    return _underscore.default.map(value, (v, index) => index === 1 ? v.toLowerCase() : v);
  }

  if (_underscore.default.isEmpty(orderby)) {
    return {};
  }

  let $orderby;

  if (_underscore.default.isArray(orderby)) {
    $orderby = _underscore.default.map(orderby, value => lowerCaseOrderValue(value).join(' ')).join(',');
  } else {
    $orderby = _underscore.default.map(orderby, (value, key) => `${key} ${value > 0 ? 'asc' : 'desc'}`).join(',');
  }

  return {
    $orderby
  };
} // TODO: [yaoyao] add support to parse filter object


function parseFilter(filter) {
  if (_underscore.default.isEmpty(filter) || _underscore.default.isEmpty(filter.where)) {
    return {};
  }

  return {
    $filter: filter.where
  };
}

function parseTop(top) {
  if (!top) {
    return {};
  }

  return {
    $top: top
  };
}

function parseSkip(skip) {
  if (!skip) {
    return {};
  }

  return {
    $skip: skip
  };
}

function parseCount(count) {
  if (count === undefined) {
    return {};
  }

  return {
    $count: count
  };
}

function parseSelect(select, resource) {
  if (!select) return {};
  const parsed = {};
  const elementType = resource.type.elementType ? resource.type.elementType : resource.type;
  const navigationPropertyNames = elementType.navigationPropertyNames;
  const $select = select.filter(item => !_underscore.default.contains(navigationPropertyNames, item)).join(',');
  const $expand = select.filter(item => _underscore.default.contains(navigationPropertyNames, item)).join(',');

  if ($select.length) {
    parsed.$select = $select;
  }

  if ($expand.length) {
    parsed.$expand = $expand;
  }

  return parsed;
}

function parseSearch(search) {
  if (!search) {
    return {};
  }

  return {
    $search: search
  };
} // TODO: make all the legacy findall call related logic to a separate edm plugin package
// backward compatibility for legacy grid jsdata resource finall call


const legacyJsDataResultProcess = response => {
  const result = response.value.slice();
  Object.defineProperty(result, 'totalCount', {
    value: response['@odata.count'],
    enumerable: false
  });
  Object.defineProperty(result, 'raw', {
    value: response,
    enumerable: false
  });
  return result;
};
/**
 * @param {EDM} edm - The EDM object to apply the plugin to
 * @param {String} rootURL - The root URL of the OData service
 * @param {object} dependants - The entity dependency relations
 * @param {object} processOptions - The options to process response and error
 * @return {Void} nothing to return
 */


function odataPlugin(edm, rootURL, dependants = {}, {
  processResponse = _underscore.default.identity,
  processError = _underscore.default.identity,
  processOptions = _underscore.default.identity
} = {}) {
  const odataRootURL = rootURL.replace(/\/*$/, '');

  if ((0, _reflection.hasOwnProperty)(edm, 'odata')) {
    return;
  }

  const wrapODataMethod = (method, resource) => function wrappedODataMethod(odataURL, options) {
    return method(odataURL, processOptions(options, resource)).then(response => processResponse(response, resource)).catch(error => {
      throw processError(error, resource);
    });
  };

  (0, _cache.odataCachePlugin)(edm, dependants, {
    fetchEntity: (resource, {
      select
    }) => wrapODataMethod(_httpUtil.odata.get, resource)(resource.odataURL, {
      data: _objectSpread({}, parseSelect(select, resource))
    }),
    patchEntity: (resource, {
      select
    }, update) => wrapODataMethod(_httpUtil.odata.patch, resource)(resource.odataURL, {
      data: update,
      urlParameters: _objectSpread({}, parseSelect(select, resource))
    }),
    createEntity: (collectionResource, {
      select
    }, data) => wrapODataMethod(_httpUtil.odata.post, collectionResource)(collectionResource.odataURL, {
      data,
      urlParameters: _objectSpread({}, parseSelect(select, collectionResource))
    }),
    deleteEntity: resource => wrapODataMethod(_httpUtil.odata.delete, resource)(resource.odataURL),
    fetchCollection: (collectionResource, _ref) => {
      let top = _ref.top,
          skip = _ref.skip,
          count = _ref.count,
          orderby = _ref.orderby,
          filter = _ref.filter,
          select = _ref.select,
          search = _ref.search,
          others = _objectWithoutProperties(_ref, ["top", "skip", "count", "orderby", "filter", "select", "search"]);

      return wrapODataMethod(_httpUtil.odata.get, collectionResource)(collectionResource.odataURL, {
        data: _objectSpread({
          $top: top,
          $skip: skip,
          $count: count
        }, parseOrderBy(orderby), parseFilter(filter), parseSelect(select, collectionResource), parseSearch(search), others)
      });
    },
    action: (collectionResource, {
      top,
      skip,
      count,
      orderby,
      filter,
      select,
      payload
    }) => wrapODataMethod(_httpUtil.odata.post, collectionResource)(collectionResource.odataURL, {
      data: _objectSpread({}, payload),
      urlParameters: _objectSpread({}, parseTop(top), parseSkip(skip), parseCount(count), parseOrderBy(orderby), parseFilter(filter), parseSelect(select, collectionResource))
    })
  });
  const _edm$odataCache = edm['odata.cache'],
        getEntity = _edm$odataCache.getEntity,
        postEntity = _edm$odataCache.postEntity,
        destroyEntityAsPromise = _edm$odataCache.destroyEntityAsPromise,
        entityAction = _edm$odataCache.entityAction,
        getCollection = _edm$odataCache.getCollection,
        collectionAction = _edm$odataCache.collectionAction;
  (0, _edmResourceIdentifiers.resIdsPlugin)(edm);
  /**
   * @name edm
   * @property {Object} odata - A dummy indicator for odataPlugin being applied
   */

  (0, _reflection.defineConstProperty)(edm, 'odata', (() => {
    const _edm$resourceIdentifi = edm.resourceIdentifiers,
          ResourceIdentifier = _edm$resourceIdentifi.ResourceIdentifier,
          CollectionResourceIdentifier = _edm$resourceIdentifi.CollectionResourceIdentifier,
          Navigation = _edm$resourceIdentifi.Navigation;
    (0, _reflection.defineProducedPropertyOnClass)(ResourceIdentifier, 'odataURL',
    /**
     * @memberof ResourceIdentifier#
     * @this ResourceIdentifier
     * @returns {String} The URL to access the OData resource
     */
    function () {
      // eslint-disable-line func-names
      return url.join(odataRootURL, this.path);
    }); // edm.currentCustomer.Accounts is an instance of ResourceIdentifier
    // usage:
    // edm.currentCustomer.Accounts.get({ top: 20, skip: 10 })
    // TODO:
    //   * type enrichment, for example, 'Active' => Enum.CampaignStatus'Active'
    //   * type check
    //   * cache and onChange event on response

    CollectionResourceIdentifier.prototype.get = function get(_ref2 = {}, hardResetData) {
      let _ref2$top = _ref2.top,
          top = _ref2$top === void 0 ? 20 : _ref2$top,
          _ref2$skip = _ref2.skip,
          skip = _ref2$skip === void 0 ? 0 : _ref2$skip,
          _ref2$count = _ref2.count,
          count = _ref2$count === void 0 ? true : _ref2$count,
          _ref2$select = _ref2.select,
          select = _ref2$select === void 0 ? null : _ref2$select,
          _ref2$filter = _ref2.filter,
          filter = _ref2$filter === void 0 ? null : _ref2$filter,
          _ref2$orderby = _ref2.orderby,
          orderby = _ref2$orderby === void 0 ? null : _ref2$orderby,
          _ref2$search = _ref2.search,
          search = _ref2$search === void 0 ? null : _ref2$search,
          others = _objectWithoutProperties(_ref2, ["top", "skip", "count", "select", "filter", "orderby", "search"]);

      return getCollection(this, _objectSpread({
        top,
        skip,
        count,
        select,
        filter,
        orderby,
        search
      }, others), hardResetData);
    };

    ResourceIdentifier.prototype.get = function get({
      // when null means default response
      // most likely it would includes all non navigation property and exclude all navigation ones
      select = null
    } = {}, hardResetData) {
      return getEntity(this, {
        select
      }, hardResetData);
    };

    ResourceIdentifier.prototype.patch = function patch(data, {
      select = null
    } = {}) {
      const cacheItem = getEntity(this, {
        select
      });
      return cacheItem.update(data);
    }; // NOTE: likezh: DELETE operation returns a Promise, not an observable.
    // See comments in cache.js.


    ResourceIdentifier.prototype.destroyAsPromise = function destroy() {
      return destroyEntityAsPromise(this);
    };

    ResourceIdentifier.prototype.$_callableMakeCall = function $callableMakeCall({
      top,
      skip,
      count,
      orderby = null,
      filter = null,
      select = null,
      payload,
      hardResetData
    } = {}) {
      if (this.type instanceof edm.types.CollectionType) {
        if (this.navigation.source.type instanceof edm.types.ActionType) {
          return collectionAction(this, {
            top: top || 20,
            skip: skip || 0,
            count: count === undefined ? true : count,
            orderby,
            filter,
            select,
            payload
          });
        } else if (this.navigation.source.type instanceof edm.types.FunctionType) {
          return getCollection(this, {
            top: top || 20,
            skip: skip || 0,
            count: count === undefined ? true : count,
            orderby,
            filter,
            select
          }, hardResetData);
        }
      } // In theory, we should not have param like top, count, filter and orderby
      // for none collectionType. But the Odata metadata have some incorrect information
      // that return type of collection is marked as none collection


      if (this.navigation.source.type instanceof edm.types.ActionType) {
        return entityAction(this, {
          top,
          skip,
          count,
          orderby,
          filter,
          select,
          payload
        });
      }

      return getEntity(this, {
        top,
        skip,
        count,
        orderby,
        filter,
        select
      }, hardResetData);
    };

    ResourceIdentifier.prototype.$makeCall = function $makeCall({
      query,
      functionParams,
      payload,
      hardResetData
    } = {}) {
      return this.$call(functionParams).$_callableMakeCall(_objectSpread({}, query, {
        payload,
        hardResetData
      }));
    }; // align with jsdata, to ensure backward compatibility with jsdata data source.


    ResourceIdentifier.prototype.findAll = function findAll(query = {}) {
      if (this.type instanceof edm.types.ActionType) {
        return this.$makeCall({
          query: {
            top: query.limit || 20,
            skip: query.offset || 0,
            count: true,
            orderby: query.orderBy,
            filter: query.filter,
            select: query.select
          },
          payload: query.query
        }).toPromise().then(legacyJsDataResultProcess);
      }

      throw new Error('findall call for this type is not suported');
    };

    (0, _reflection.defineProducedPropertyOnClass)(CollectionResourceIdentifier, 'idAttribute', function idAttribute() {
      return this.type.elementType.key;
    });

    CollectionResourceIdentifier.prototype.post = function post(data, {
      select = null
    } = {}) {
      return postEntity(this, {
        select
      }, data);
    }; // usage:
    // edm.currentCustomer.Accounts.findAll({ limit: 20 }), align with jsdata
    // TODO:
    //   * refine available options, jsdata aligned arguments


    CollectionResourceIdentifier.prototype.findAll = function findAll(query = {}) {
      return this.get({
        top: query.limit
      }).toPromise().then(legacyJsDataResultProcess);
    }; // usage:
    // edm.currentCustomer.Accounts.update(123, { Name: 'another name' }), align with jsdata


    CollectionResourceIdentifier.prototype.update = function update(id, data) {
      return this.$withKey(id).patch(data).toPromise();
    };

    (0, _reflection.defineProducedPropertyOnClass)(Navigation, 'odataURL',
    /**
     * @memberof Navigation#
     * @this Navigation
     * @returns {String} The URL to access the OData resource
     */
    function () {
      // eslint-disable-line func-names
      return url.join(odataRootURL, this.path);
    }); // put the plugin indicator

    return {
      odataRootURL
    };
  })());
}

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.odataCachePlugin = odataCachePlugin;

var _reflection = __webpack_require__(39);

var _jsonStableStringify = _interopRequireDefault(__webpack_require__(74));

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _bluebird = _interopRequireDefault(__webpack_require__(6));

var _serverCallCacheItem = __webpack_require__(75);

var _observableCache = __webpack_require__(77);

var _cacheEvent = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function odataCachePlugin(edm, dependants, {
  fetchEntity,
  patchEntity,
  createEntity,
  deleteEntity,
  fetchCollection,
  action
}) {
  const entityDeps = dependants || {};
  (0, _reflection.defineConstProperty)(edm, 'odata.cache', (() => {
    // TODO: when collection cache is ready, use the response to fill up entity cache
    const collectionCache = new _observableCache.ObservableCache();
    const cacheEvent = new _cacheEvent.CacheEvent();

    function getCollection(collectionResource, options, hardResetCacheData) {
      const typeName = collectionResource.type.elementType.name;
      const path = collectionResource.path;
      const stringifiedOptions = (0, _jsonStableStringify.default)(options);
      const cacheKeyPath = [typeName, path, stringifiedOptions];
      const item = collectionCache.get(cacheKeyPath);

      if (item) {
        if (hardResetCacheData) {
          item.setData(hardResetCacheData);
        }

        return item;
      }

      const newItem = new _serverCallCacheItem.CollectionCacheItem({
        fetch: () => fetchCollection(collectionResource, options),
        afterSubscribe: cache => collectionCache.observerAdded(cache, cacheKeyPath),
        afterUnsubscribe: cache => collectionCache.observerReduced(cache, cacheKeyPath),
        hardResetCacheData
      });
      collectionCache.set(cacheKeyPath, newItem);
      return newItem;
    }

    function collectionAction(collectionResource, options) {
      const typeName = collectionResource.type.elementType.name;
      const path = collectionResource.path;
      const stringifiedOptions = (0, _jsonStableStringify.default)(options);
      const cacheKeyPath = [typeName, path, stringifiedOptions];
      const item = collectionCache.get(cacheKeyPath);

      if (item) {
        return item;
      }

      const newItem = new _serverCallCacheItem.CollectionCacheItem({
        fetch: () => action(collectionResource, options),
        afterSubscribe: cache => collectionCache.observerAdded(cache, cacheKeyPath),
        afterUnsubscribe: cache => collectionCache.observerReduced(cache, cacheKeyPath)
      });
      collectionCache.set(cacheKeyPath, newItem);
      return newItem;
    }

    const entityCache = new _observableCache.ObservableCache();

    function invalidateCollectionCache(typeName) {
      _underscore.default.each(collectionCache.observedCache[typeName], cacheItems => {
        _underscore.default.each(cacheItems, cacheItem => {
          cacheItem.invalidate();
        });
      });

      Object.keys(collectionCache.noObservers.entries).forEach(key => {
        if (JSON.parse(key)[0] === typeName) {
          collectionCache.invalidateNoObserverCache(key);
        }
      });
    }

    function invalidateEntityCache(typeName, id, stringifiedOptions) {
      const forAll = !id;

      if (entityCache.observedCache[typeName]) {
        if (forAll) {
          _underscore.default.each(entityCache.observedCache[typeName], cacheItems => {
            _underscore.default.each(cacheItems, cacheItem => {
              cacheItem.invalidate();
            });
          });
        } else {
          _underscore.default.each(entityCache.observedCache[typeName][id], (cacheItem, options) => {
            if (options !== stringifiedOptions) {
              cacheItem.invalidate();
            }
          });
        }
      }

      Object.keys(entityCache.noObservers.entries).forEach(key => {
        const _JSON$parse = JSON.parse(key),
              _JSON$parse2 = _slicedToArray(_JSON$parse, 3),
              type = _JSON$parse2[0],
              parsedId = _JSON$parse2[1],
              options = _JSON$parse2[2];

        if (type === typeName && (forAll || parsedId === id && options !== stringifiedOptions)) {
          entityCache.invalidateNoObserverCache(key);
        }
      });
    }

    function invalidate(typeName, id, stringifiedOptions, context) {
      // eslint-disable-next-line no-param-reassign
      context[typeName] = true;
      invalidateCollectionCache(typeName);
      invalidateEntityCache(typeName, id, stringifiedOptions);

      _underscore.default.each(entityDeps[typeName], type => {
        if (!context[type]) {
          // eslint-disable-next-line no-param-reassign
          context[type] = true;
          invalidate(type, null, '', context);
        }
      });

      cacheEvent.notify('invalidate', typeName);
    }

    function invalidateTypeCache(typeName, id = null, stringifiedOptions = '') {
      invalidate(typeName, id, stringifiedOptions, {});
    }

    function getEntity(resource, options, hardResetCacheData) {
      const typeName = resource.type.name; // entity odata function call will use the api, in this case we need to use path as hash key

      const idOrPath = resource.navigation.key || resource.path;
      const stringifiedOptions = (0, _jsonStableStringify.default)(options);
      const cacheKeyPath = [typeName, idOrPath, stringifiedOptions];
      const item = entityCache.get(cacheKeyPath);

      if (item) {
        if (hardResetCacheData) {
          item.setData(hardResetCacheData);
        }

        return item;
      }

      const newItem = new _serverCallCacheItem.EntityCacheItem({
        fetch: () => fetchEntity(resource, options),
        patch: update => patchEntity(resource, options, update).tap(() => invalidateTypeCache(typeName, idOrPath, stringifiedOptions)),
        afterSubscribe: cache => entityCache.observerAdded(cache, cacheKeyPath),
        afterUnsubscribe: cache => entityCache.observerReduced(cache, cacheKeyPath),
        hardResetCacheData
      });
      entityCache.set(cacheKeyPath, newItem);
      return newItem;
    }

    function entityAction(resource, options) {
      const typeName = resource.type.name;
      const path = resource.navigation.path;
      const stringifiedOptions = (0, _jsonStableStringify.default)(options);
      const cacheKeyPath = [typeName, path, stringifiedOptions];
      const item = entityCache.get(cacheKeyPath);

      if (item) {
        return item;
      }

      const newItem = new _serverCallCacheItem.EntityCacheItem({
        fetch: () => action(resource, options),
        afterSubscribe: cache => entityCache.observerAdded(cache, cacheKeyPath),
        afterUnsubscribe: cache => entityCache.observerReduced(cache, cacheKeyPath)
      });
      entityCache.set(cacheKeyPath, newItem);
      return newItem;
    }

    function postEntity(collectionResource, options, data) {
      const stringifiedOptions = (0, _jsonStableStringify.default)(options);
      const entityPromise = createEntity(collectionResource, options, data);
      const keyProperty = collectionResource.type.elementType.key;
      const typeName = collectionResource.type.elementType.name;
      const resourcePromise = entityPromise.then(entity => collectionResource.$withKey(entity[keyProperty]));
      let fetchFirstCalledAndPatchNotCalled = true;
      const newItem = new _serverCallCacheItem.EntityCacheItem({
        fetch: () => {
          if (fetchFirstCalledAndPatchNotCalled) {
            fetchFirstCalledAndPatchNotCalled = false;
            return entityPromise;
          }

          return resourcePromise.then(resource => fetchEntity(resource, options));
        },
        patch: update => {
          fetchFirstCalledAndPatchNotCalled = false;
          return resourcePromise.tap(resource => invalidateTypeCache(typeName, resource.navigation.key, stringifiedOptions)).then(resource => patchEntity(resource, options, update));
        }
      });
      resourcePromise.then(resource => {
        const id = resource.navigation.key;
        const cacheKeyPath = [typeName, id, stringifiedOptions];

        newItem.afterSubscribe = cache => entityCache.observerAdded(cache, cacheKeyPath);

        newItem.afterUnsubscribe = cache => entityCache.observerReduced(cache, cacheKeyPath);

        entityCache.set(cacheKeyPath, newItem);
        invalidateTypeCache(typeName, id, stringifiedOptions);
      });
      return newItem;
    }

    function destroyEntityAsPromise(resource) {
      const typeName = resource.type.name;
      const id = resource.navigation.key; // NOTE: likezh: for delete, since the effect of deletion will be an entity being removed,
      // it is not useful to keep the call in cache. Hence we're directly returning a Promise here.

      return new _bluebird.default((resolve, reject) => {
        deleteEntity(resource).then(() => {
          invalidateTypeCache(typeName, id, '');
          resolve();
        }).catch(err => reject(err));
      });
    }

    return {
      getEntity,
      postEntity,
      destroyEntityAsPromise,
      entityAction,
      getCollection,
      collectionAction,
      invalidateTypeCache,
      cacheEvent
    };
  })());
}

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__74__;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCacheItem = exports.CollectionCacheItem = void 0;

var _underscore = __webpack_require__(7);

var _observable = __webpack_require__(76);

/**
 * make a server call and setup the cache item state
 * @param {Function} call function returns a Promise of data
 * @returns {Promise} a resolved promise
 */
function makeCall(call) {
  this.state.status = 'PENDING';
  return call().then(data => {
    this.setData(data);
    return null;
  }).catch(err => {
    this.observers.forEach(item => {
      item.error(err);
    });
    this.state.status = 'ERROR';
    this.state.error = err;
  });
}

class CacheItem extends _observable.Observable {
  constructor({
    fetch,
    afterSubscribe = _underscore.noop,
    afterUnsubscribe = _underscore.noop,
    hardResetCacheData
  }) {
    super(observer => {
      this.observers.add(observer);
      this.afterSubscribe(this);

      if (this.state.status === 'WAITING') {
        if (hardResetCacheData) {
          this.setData(hardResetCacheData);
        } else {
          this.invalidate();
        }
      } else if (this.state.status === 'READY') {
        observer.next(this.state.data);
      } else if (this.state.status === 'ERROR') {
        observer.error(this.state.error);
      }

      return () => {
        this.observers.delete(observer);
        this.afterUnsubscribe(this);
      };
    });
    this.fetch = fetch; // eslint-disable-next-line no-undef

    this.observers = new Set();
    this.afterSubscribe = afterSubscribe;
    this.afterUnsubscribe = afterUnsubscribe;
    this.state = {
      // WAITING - before any subscription
      // PENDING - has subscription, call made but not responded
      // READY - already has data
      // ERROR - already has error
      status: 'WAITING',
      data: null,
      error: null
    };
  }

  setData(data) {
    this.observers.forEach(item => {
      item.next(data);
    });
    this.state.status = 'READY';
    this.state.data = data;
    return null;
  }

  invalidate() {
    if (this.observers.size === 0) {
      this.state.status = 'WAITING';
    } else {
      makeCall.call(this, () => this.fetch());
    }
  }

  hasObservers() {
    return this.observers.size > 0;
  }

}

class CollectionCacheItem extends CacheItem {}

exports.CollectionCacheItem = CollectionCacheItem;

class PatchEntityCacheItem extends _observable.Observable {
  constructor() {
    super(observer => {
      this.observers.add(observer);

      if (this.state.status === 'READY') {
        observer.next(this.state.data);
      } else if (this.state.status === 'ERROR') {
        observer.error(this.state.error);
      }

      return () => {
        this.observers.delete(observer);
      };
    }); // eslint-disable-next-line no-undef

    this.observers = new Set();
    this.state = {
      // WAITING - before any subscription
      // READY - already has data
      // ERROR - already has error
      status: 'WAITING',
      data: null,
      error: null
    };
  }

  next(data) {
    this.observers.forEach(item => {
      item.next(data);
    });
    this.state.status = 'READY';
    this.state.data = data;
  }

  error(err) {
    this.observers.forEach(item => {
      item.error(err);
    });
    this.state.status = 'ERROR';
    this.state.error = err;
  }

}

class EntityCacheItem extends CacheItem {
  constructor({
    fetch,
    patch,
    afterSubscribe = _underscore.noop,
    afterUnsubscribe = _underscore.noop,
    hardResetCacheData
  }) {
    super({
      fetch,
      afterSubscribe,
      afterUnsubscribe,
      hardResetCacheData
    });
    this.patch = patch;
  }

  update(update) {
    const patchEntityCacheItem = new PatchEntityCacheItem();
    const originalStatus = this.state.status;
    this.state.status = 'PENDING';
    this.patch(update).then(data => {
      this.observers.forEach(item => {
        item.next(data);
      });
      this.state.status = 'READY';
      this.state.data = data;
    }).catch(err => {
      patchEntityCacheItem.error(err);
      this.state.status = originalStatus;
    });
    this.subscribe({
      next: data => patchEntityCacheItem.next(data),
      error: err => patchEntityCacheItem.error(err)
    });
    return patchEntityCacheItem;
  }

}

exports.EntityCacheItem = EntityCacheItem;

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__76__;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObservableCache = void 0;

var _primitiveUtilities = __webpack_require__(8);

var _jsonStableStringify = _interopRequireDefault(__webpack_require__(74));

var _timeAwareCache = __webpack_require__(78);

var _constants = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function deletePropertyPath(obj, path) {
  let o = obj;
  const length = path.length;

  for (let i = 0; i < length - 1; i += 1) {
    o = o[path[i]];

    if (typeof o === 'undefined') {
      return;
    }
  }

  delete o[path[length - 1]];
}

class ObservableCache {
  constructor() {
    _defineProperty(this, "observedCache", {});

    _defineProperty(this, "noObservers", new _timeAwareCache.TimeAwareCache({
      ttl: _constants.DEFAULT_TTL,
      strategy: new _timeAwareCache.LRUReplacementStrategy({
        limit: _constants.CACHE_SIZE
      })
    }));
  }

  set(path, item) {
    if (item.hasObservers()) {
      (0, _primitiveUtilities.set)(this.observedCache, path, item);
    } else {
      this.noObservers.set((0, _jsonStableStringify.default)(path), item);
    }
  }

  get(path) {
    return (0, _primitiveUtilities.get)(this.observedCache, path) || this.noObservers.get((0, _jsonStableStringify.default)(path));
  }

  observerAdded(item, path) {
    if (item.observers.size === 1) {
      this.noObservers.del((0, _jsonStableStringify.default)(path));
      (0, _primitiveUtilities.set)(this.observedCache, path, item);
    }
  }

  observerReduced(item, path) {
    if (item.observers.size === 0) {
      deletePropertyPath(this.observedCache, path);
      this.noObservers.set((0, _jsonStableStringify.default)(path), item);
    }
  }

  invalidateNoObserverCache(key) {
    const cache = this.noObservers.get(key);

    if (cache) {
      cache.invalidate();
    }
  }

}

exports.ObservableCache = ObservableCache;

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__78__;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TTL = exports.LLT_EXPIRED = exports.CACHE_SIZE = void 0;
const CACHE_SIZE = 200;
exports.CACHE_SIZE = CACHE_SIZE;
const LLT_EXPIRED = -1; // time to live defaults to 2 hours

exports.LLT_EXPIRED = LLT_EXPIRED;
const DEFAULT_TTL = 2 * 60 * 60 * 1000;
exports.DEFAULT_TTL = DEFAULT_TTL;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CacheEvent = void 0;

var _observable = __webpack_require__(76);

class CacheEvent extends _observable.Observable {
  constructor() {
    super(observer => {
      this.observers.add(observer);
      return () => {
        this.observers.delete(observer);
      };
    }); // eslint-disable-next-line no-undef

    this.observers = new Set();
  }

  notify(type, entity) {
    this.observers.forEach(ob => {
      ob.next({
        type,
        entity
      });
    });
  }

}

exports.CacheEvent = CacheEvent;

/***/ })

/******/ });
});
